import { Injectable } from '@angular/core';
import { AlertService } from '@ddv/common-components';
import { ADDITIONAL_FILTERS_WITH_NO_VALUES_MESSAGE } from '@ddv/models';

import { ErrorLogger } from './error-logger';

@Injectable()
export class ErrorLoggerService implements ErrorLogger {
    constructor(private readonly alertService: AlertService) {}

    logError(_: string, error: Error): void {
        if (error.message && !error.message.includes(ADDITIONAL_FILTERS_WITH_NO_VALUES_MESSAGE)) {
            this.alertService.warn(error.message);
        }
    }
}
